import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';

import "./CreatePollModalContent.css";

class CreatePollModalContent extends Component {

    render() {
        return (
            <CreatePollModalForm onClose={this.props.onClose} />
        );
    }

}

const INITIAL_STATE = {
    question: '',
    answers: { answer1: '', answer2: '' },
    extraAnswerFields: [],
    nbAnswerFields: 2,
    email: '',
    error: null,
    current_user: '',
};

class DocumentInput extends Component {
    render() {
        return (
            <input
                onChange={this.props.onChange}
                type="modal-poll"
                className="modal-poll-answer-field container placeholder-label"
                name={`answer${this.props.index + 3}`}
                placeholder={`Réponse n°${this.props.index + 3}`}
                value={this.props.value}
                maxLength="50" />)
    }
}


class CreatePollModalFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

        this.add = this.add.bind(this);
    }

    componentDidMount() {
        let uid;
        if (this.props.firebase.auth.currentUser) {
            uid = this.props.firebase.auth.currentUser.uid
            this.setState({ current_user: uid });
        }
    }

    add() {
        const extraAnswerFields = this.state.extraAnswerFields.concat(DocumentInput);
        this.setState({ extraAnswerFields, nbAnswerFields: this.state.nbAnswerFields + 1 });
    }

    onSubmit = event => {
        const { question, answers, current_user } = this.state;
        this.props.onAddPolls({ question: question, answers: answers, creatorId: current_user, creationDate: new Date().getTime() });
        event.preventDefault();
        this.props.onClose();
    };

    onChange = event => {

        if (event.target.name === 'question') {
            this.setState({ [event.target.name]: event.target.value });
        }
        else {
            this.setState({
                answers: Object.assign({},
                    this.state.answers, { [event.target.name]: event.target.value })
            })
        }
    };

    render() {
        const { question, error, answers } = this.state;

        const additionalAnswers = this.state.extraAnswerFields.map((Element, index) => {
            return <Element onChange={this.onChange} key={index} index={index} value={this.state.answers[`answers${index + 3}`]} /> //index + 3 because we already have 2 answers
        });

        return (

            <>

                <div className="create-poll-container">

                    <div className="modal-poll-header">
                        <img className="modal-poll-little-img" src={require('../../assets/polls/soucoupe_little.svg')} alt="Small" />
                        <div className="modal-poll-title">Créer un sondage</div>
                        <img className="modal-poll-big-img" src={require('../../assets/polls/soucoupe_big.svg')} alt="Big" />
                    </div>


                    <form onSubmit={this.onSubmit}>

                        <div className="modal-poll-form-container-mobile">

                            <div>
                                <div className="modal-poll-form-group">
                                    <label htmlFor="question" className="modal-poll-basic-text">Quelle est votre question ?</label>
                                    <input onChange={this.onChange} value={question} type="modal-poll" className="modal-poll-question-field container placeholder-label" name="question" placeholder="Ecrivez votre question" />

                                    <label htmlFor="answer" className="modal-poll-basic-text">Réponses</label>
                                    <input onChange={this.onChange} value={answers.answer1} type="modal-poll" className="modal-poll-answer-field container placeholder-label" name="answer1" placeholder="Réponse n°1" maxlength="50" />
                                    <input onChange={this.onChange} value={answers.answer2} type="modal-poll" className="modal-poll-answer-field container placeholder-label" name="answer2" placeholder="Réponse n°2" maxlength="50" />
                                    {additionalAnswers}

                                    <div className="modal-poll-footer">
                                        <button type="button" onClick={this.add} className="modal-poll-button-add">+ Ajouter une réponse</button>
                                        <button onClick={this.onSubmit} className="modal-poll-button" disabled={answers.answer1.length === 0 || answers.answer2.length === 0}>OK</button>
                                    </div>


                                </div>
                            </div>

                            {error && <p>{error.message}</p>}
                        </div>

                    </form>
                </div>
            </>
        );
    }
}


const CreatePollModalForm = withRouter(withFirebase(CreatePollModalFormBase));


export { CreatePollModalContent };
export default CreatePollModalForm;
